import { render, staticRenderFns } from "./OurPartners.vue?vue&type=template&id=44ffee63&scoped=true&"
import script from "./OurPartners.vue?vue&type=script&lang=js&"
export * from "./OurPartners.vue?vue&type=script&lang=js&"
import style0 from "./OurPartners.vue?vue&type=style&index=0&id=44ffee63&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ffee63",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCol,VContent,VRow,VSlideXReverseTransition,VSlideXTransition,VSlideYTransition})
